'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Base = require('../base');
var Common = require('../common');
var Messages = require('../messages');
var internals = {};
module.exports = Base.extend({
  type: 'any',
  flags: {
    only: {
      default: false
    }
  },
  terms: {
    alterations: {
      init: null
    },
    examples: {
      init: null
    },
    externals: {
      init: null
    },
    metas: {
      init: []
    },
    notes: {
      init: []
    },
    shared: {
      init: null
    },
    tags: {
      init: []
    },
    whens: {
      init: null
    }
  },
  rules: {
    custom: {
      method: function method(_method, description) {
        Assert(typeof _method === 'function', 'Method must be a function');
        Assert(description === undefined || description && typeof description === 'string', 'Description must be a non-empty string');
        return this.$_addRule({
          name: 'custom',
          args: {
            method: _method,
            description: description
          }
        });
      },
      validate: function validate(value, helpers, _ref) {
        var method = _ref.method;
        try {
          return method(value, helpers);
        } catch (err) {
          return helpers.error('any.custom', {
            error: err
          });
        }
      },
      args: ['method', 'description'],
      multi: true
    },
    messages: {
      method: function method(messages) {
        return this.prefs({
          messages: messages
        });
      }
    },
    shared: {
      method: function method(schema) {
        Assert(Common.isSchema(schema) && schema._flags.id, 'Schema must be a schema with an id');
        var obj = this.clone();
        obj.$_terms.shared = obj.$_terms.shared || [];
        obj.$_terms.shared.push(schema);
        obj.$_mutateRegister(schema);
        return obj;
      }
    },
    warning: {
      method: function method(code, local) {
        Assert(code && typeof code === 'string', 'Invalid warning code');
        return this.$_addRule({
          name: 'warning',
          args: {
            code: code,
            local: local
          },
          warn: true
        });
      },
      validate: function validate(value, helpers, _ref2) {
        var code = _ref2.code,
          local = _ref2.local;
        return helpers.error(code, local);
      },
      args: ['code', 'local'],
      multi: true
    }
  },
  modifiers: {
    keep: function keep(rule) {
      var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      rule.keep = enabled;
    },
    message: function message(rule, _message) {
      rule.message = Messages.compile(_message);
    },
    warn: function warn(rule) {
      var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      rule.warn = enabled;
    }
  },
  manifest: {
    build: function build(obj, desc) {
      for (var key in desc) {
        var values = desc[key];
        if (['examples', 'externals', 'metas', 'notes', 'tags'].includes(key)) {
          var _iterator = _createForOfIteratorHelper(values),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var value = _step.value;
              obj = obj[key.slice(0, -1)](value);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          continue;
        }
        if (key === 'alterations') {
          var alter = {};
          var _iterator2 = _createForOfIteratorHelper(values),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _step2.value,
                target = _step2$value.target,
                adjuster = _step2$value.adjuster;
              alter[target] = adjuster;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          obj = obj.alter(alter);
          continue;
        }
        if (key === 'whens') {
          var _iterator3 = _createForOfIteratorHelper(values),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _value = _step3.value;
              var ref = _value.ref,
                is = _value.is,
                not = _value.not,
                then = _value.then,
                otherwise = _value.otherwise,
                concat = _value.concat;
              if (concat) {
                obj = obj.concat(concat);
              } else if (ref) {
                obj = obj.when(ref, {
                  is: is,
                  not: not,
                  then: then,
                  otherwise: otherwise,
                  switch: _value.switch,
                  break: _value.break
                });
              } else {
                obj = obj.when(is, {
                  then: then,
                  otherwise: otherwise,
                  break: _value.break
                });
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          continue;
        }
        if (key === 'shared') {
          var _iterator4 = _createForOfIteratorHelper(values),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _value2 = _step4.value;
              obj = obj.shared(_value2);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
      return obj;
    }
  },
  messages: {
    'any.custom': '{{#label}} failed custom validation because {{#error.message}}',
    'any.default': '{{#label}} threw an error when running default method',
    'any.failover': '{{#label}} threw an error when running failover method',
    'any.invalid': '{{#label}} contains an invalid value',
    'any.only': '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
    'any.ref': '{{#label}} {{#arg}} references "{{#ref}}" which {{#reason}}',
    'any.required': '{{#label}} is required',
    'any.unknown': '{{#label}} is not allowed'
  }
});